import { MOCKING_ENABLED } from './config';
import { worker } from './browser';

export async function enableMocking(): Promise<void> {
  if (!MOCKING_ENABLED) {
    return;
  }

  await worker.start({ onUnhandledRequest: 'bypass' });
}
